import React from "react";
import styles from "./loading4.module.scss";

const Loading = ()=> 
    <div className={styles.loading}>
        <div className={styles["twin-circles"]}></div>
    </div>


export default Loading;